import { useDispatch, useSelector } from 'react-redux'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  LaboratoryPrescriptiuonType as LaboratoryPrescriptionType,
  PrescriptionViewModel,
} from '../../../models/ViewModels/PrescriptionViewModel'
import { LoadingFit, RaytebModal } from '../../../share/Components'
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  RaytebForm,
  Table,
  TextBox,
  Typeahead,
  TypeaheadText,
} from '../../../share/Elements'
import React, { ReactElement, useEffect, useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { LaboratoryViewModel } from '../../../models/ViewModels/LaboratoryViewModel'
import {
  addOrUpdatePrescription,
  updateLaboratoryRow,
  updateShouldPush,
} from '../../../storeManager/Reducers/prescriptionSlice'
import { toast } from 'react-toastify'
import { LaboratoryChosenViewModel } from '../../../models/ViewModels/LaboratoryChosenViewModel'
import { ErrorTypeEnum } from '../../../_services/ResponseErrorType'
import { GetPriceViewModel } from '../../../models/ViewModels/GetPriceViewModel'
type TypeaheadData = {
  show: boolean
  data?: any
}
const Laboratory = ({
  laboratory,
  prescriptionId,
  isPreview,
  setButtomPage,
}: {
  laboratory: LaboratoryPrescriptionType
  prescriptionId: string
  isPreview?: boolean
  setButtomPage?: (child: ReactElement | null) => void
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dispatch = useDispatch()
  const [data, setData] = useState<LaboratoryServeViewModel>({})
  const [showBookmark, setShowBookmark] = useState<boolean>(false)
  const [listBookmarkSearch, setListBookmarkSearch] = useState<
    Array<ListBookmarkViewModel> | undefined
  >([])
  const listBookmark = useFetch<Array<ListBookmarkViewModel>>({
    request: RaytebRequests.Laboratory_Bookmark_Get({
      token: user.token,
    }),
    onSuccess(data) {
      setListBookmarkSearch(data)
    },
  })
  const bookmark = useFetch<
    unknown,
    unknown,
    { laboratoryId: string; title: string }
  >({
    request: RaytebRequests.Laboratory_Bookmark_POST({ token: user.token }),
    onSuccess(data) {
      toast.success('نسخه برگزیده با موفقیت ثبت شد')
      setInsertBookmarkPrescriptionModal(false)
    },
  })
  const bookmarkDelete = useFetch<unknown, unknown, { bookmarkId: string }>({
    request: RaytebRequests.Laboratory_Bookmark_DELETE({ token: user.token }),
    onSuccess(data) {
      listBookmark.reFetch()
    },
  })
  const getServe = useFetch<
    Array<LaboratoryServeViewModel>,
    unknown,
    {
      prescriptionId: string
      filter: string
    }
  >({
    request: RaytebRequests.Laboratory_Serves_GET({ token: user.token }),
    onSuccess(data) { },
  })
  const [listAddedChosen, setListAddedChosen] =
    useState<LaboratoryChosenViewModel>({ rows: [], prescription: {} })
  const addChosen = useFetch<
    LaboratoryChosenViewModel,
    unknown,
    { prescriptionId: string; laboratoryId: string }
  >({
    request: RaytebRequests.Laboratory_AddChosen_Post({ token: user.token }),
    onSuccess(data) {
      setListAddedChosen(data)
      setShowListBookmark(false)
      if (data.rows?.some((n) => n.isAdded)) {
        data.prescription!.shouldPush = true
        dispatch(addOrUpdatePrescription(data.prescription))
      }
    },
  })
  const [price, setPrice] = useState<GetPriceViewModel>({})
  const getPrice = useFetch<
    GetPriceViewModel,
    unknown,
    {
      rowId: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Laboratory_GetPrice_GET({ token: user.token }),
    onSuccess(data) {
      data.show = true
      setPrice(data)
    },
  })
  const saveLaboratory = useFetch<
    LaboratoryViewModel,
    LaboratorySaveInputModel
  >({
    request: RaytebRequests.Laboratory_AddOrUpdate_POST({ token: user.token }),
    onSuccess(data) {
      dispatch(updateLaboratoryRow(data.rows))
      dispatch(updateShouldPush(true))
      setShowModal({ show: false })
      setButtomPage?.(null)
      setData({ ...data, isEdit: false, title: '', id: undefined })
      data.messages?.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const deleteLaboratory = useFetch<
    PrescriptionViewModel,
    unknown,
    {
      id: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Laboratory_Remove_DELETE({
      token: user.token,
    }),
    onSuccess(data) {
      data.shouldPush = true
      dispatch(addOrUpdatePrescription(data))
    },
  })
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  })
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
  })
  const [showListBookmark, setShowListBookmark] = useState<boolean>(true)
  const buttomElement = (
    <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
      <Button
        onClick={() => {
          setShowModal({ ...showList, show: false })
          setData({ isEdit: false })
          setButtomPage?.(null)
        }}
        className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
      >
        انصراف
      </Button>
      <Button
        onClick={() => {
          document.getElementById('saveLaboratorySubmit')?.click()
        }}
        className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg md:!w-56'
      >
        تایید
      </Button>
    </div>
  )
  const selectedItem = (item: LaboratoryServeViewModel) => {
    setData(item)
    setRowParam({ serveId: item.id })
    setShowModal({ ...showList, show: true })
    setButtomPage?.(buttomElement)
    setTimeout(() => {
      document.getElementById('TotalNumber')?.focus()
    }, 200)
    setshowList({ ...showList, show: false })
    getServe.reFetch(null, { prescriptionId: prescriptionId, filter: '' })

  }
  const [insertBookmarkPrescriptionModal, setInsertBookmarkPrescriptionModal] =
    useState<boolean>(false)
  const fieldLaboratory = 'title'
  useEffect(() => {
    if (!isPreview)
      getServe.reFetch(null, { prescriptionId: prescriptionId, filter: '' })
  }, [])

  const [rowParam, setRowParam] = useState<LaboratorySaveInputModel>({})
  return (
    <div className='py-5 relative'>
      <LoadingFit
        isLoading={
          saveLaboratory.isLoading ||
          deleteLaboratory.isLoading ||
          getPrice.isLoading
        }
      />
      {!isPreview ? (
        <>
          {' '}
          <ProvideTypeahead
            className={` ${data?.isEdit
              ? 'before:absolute before:z-50 before:bg-white/30 before:w-full before:h-full'
              : ''
              }`}
            showList={showList.show}
            listChildren={
              <ListChildren
                onClick={(item) => {
                  selectedItem(item)
                }}
                listData={getServe.result!}
                isLoading={getServe.isLoading}
                onHide={() => setshowList({ show: false })}
              />
            }
          >
            <div className='px-1 flex justify-start items-end md:!w-1/2 md:mx-auto'>
              <Typeahead
                innerText='نام یا کد خدمت آزمایشگاهی'
                className='!w-full'
                onClick={(e) => {
                  e.target.select()
                }}
                // onBlur={() =>
                //   setTimeout(() => {
                //     setshowList({ ...showList, show: false })
                //   }, 200)
                // }
                onFocus={() => setshowList({ ...showList, show: true })}
                onChange={(e) =>
                  getServe.reFetch(null, {
                    prescriptionId: prescriptionId,
                    filter: e.target.value,
                  })
                }
                value={data![fieldLaboratory]}
              >
                <Icon
                  icon='rayteb-ehr'
                  className='!text-2xl !text-primaryLight'
                  onClick={() => setShowBookmark(true)}
                />
              </Typeahead>
            </div>
          </ProvideTypeahead>
          {showModal.show ? (
            <RaytebForm
              checkIsRequired={true}
              onSubmit={(e) => {
                saveLaboratory.reFetch({
                  description: e.currentTarget['description'].value,
                  effectiveDate:
                    e.currentTarget['date'].getAttribute('rayteb-value'),
                  prescriptionId: prescriptionId,
                  amount: e.currentTarget['count'].value,
                  repeatCount: e.currentTarget['Repeat'].value,
                  serveId: rowParam.serveId!,
                  id: rowParam.id,
                  repeatType: rowParam.repeatType,
                })
              }}
            >
              <div className='w-full p-1 grid grid-cols-2 py-3 gap-x-3 gap-y-6'>
                <TextBox
                  id='TotalNumber'
                  innerText='تعداد'
                  Type={TextBoxTypeEnum.Number}
                  className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
                  isRequired={true}
                  name='count'
                  value={rowParam.amount?.toString()}
                />
                <DatePicker
                  innerText='تاریخ موثر'
                  canDeleteDate={true}
                  className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
                  value={
                    rowParam.effectiveDate
                      ? new Date(rowParam.effectiveDate).toShamsi()
                      : ''
                  }
                  name='date'
                  raytebValue={rowParam.effectiveDate}
                />
                <TypeaheadText<{
                  value: number
                  title: string
                }>
                  selected={(e) => {
                    setRowParam({ ...rowParam, repeatType: e.value })
                  }}
                  listData={[
                    { title: 'روز', value: 0 },
                    { title: 'هفته', value: 1 },
                    { title: 'ماه', value: 2 },
                  ]}
                  fieldItem='title'
                  fieldValue='value'
                  isReadOnly={false}
                  innerText='نوع تکرار نسخه'
                  className='!bg-white'
                  classNameList='h-20'
                />
                <TextBox
                  innerText='دوره تکرار'
                  Type={TextBoxTypeEnum.Number}
                  value={rowParam.repeatCount?.toString()}
                  name='Repeat'
                  className='w-full border-0 border-b rounded-none
             focus:!border-0 focus:!border-b focus:!ring-0'
                />
                <div className='col-span-2 mt-3'>
                  <TextBox
                    innerText='توضیحات دارو آزمایشگاهی'
                    Type={TextBoxTypeEnum.Text}
                    className='!w-full  h-20'
                    name='description'
                    value={rowParam.description?.toString()}
                  />
                </div>
              </div>
              <input
                type='submit'
                id='saveLaboratorySubmit'
                className='hidden'
              />
            </RaytebForm>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}

      {laboratory.rows && laboratory.rows?.length != 0 ? (
        <>
          <div className='w-full px-2 mt-6'>
            <Table>
              <thead className='text-xs text-primary h-8 border-b border-disable'>
                <tr>
                  <th scope='col' className='pr-2 text-center font-normal '>
                    کد
                  </th>
                  <th scope='col' className='pt-1 p-0 text-center font-normal'>
                    نام خدمت آزمایشگاهی
                  </th>
                  <th scope='col' className='pt-1 text-center font-normal'>
                    تعداد
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    تاریخ موثر
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody className='text-xs'>
                {laboratory.rows?.map((row, i) => (
                  <tr className='[&>*]:h-10' key={i}>
                    <td className='pr-2 text-center'>{row.sepasCode}</td>
                    <td
                      className='text-center decoration-dotted underline underline-offset-8 cursor-pointer'
                      onClick={() =>
                        getPrice.reFetch(null, {
                          prescriptionId: prescriptionId,
                          rowId: row.id!,
                        })
                      }
                    >
                      {row.title?.shortText(40)}
                    </td>
                    <td className='text-center'>{row.amount}</td>
                    <td className='text-center'>
                      {row.effectiveDate
                        ? new Date(row.effectiveDate).toShamsi()
                        : ''}
                    </td>
                    <td className='grid grid-cols-2 justify-items-center p-1 gap-1'>
                      {!row.isDeleted ? (
                        <>
                          <Icon
                            icon='rayteb-delete'
                            className='text-[17px] text-danger'
                            onClick={() => {
                              deleteLaboratory.reFetch(null, {
                                prescriptionId: prescriptionId,
                                id: row.id!,
                              })
                            }}
                            disabled={isPreview}
                          />
                          <Icon
                            icon='rayteb-edit'
                            className='text-[17px] text-warn'
                            onClick={() => {
                              setData({
                                title: row.title!,
                                id: row.id!,
                                isEdit: true,
                              })
                              setRowParam({
                                description: row.description,
                                effectiveDate: row.effectiveDate,
                                id: row.id,
                                amount: row.amount,
                                serveId: row.serveId!,
                              })
                              setShowModal({ show: true })
                              setButtomPage?.(buttomElement)
                            }}
                            disabled={isPreview}
                          />
                        </>
                      ) : (
                        ''
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <div className='flex justify-center px-2 mt-3'>
              <Button
                className=' text-xs bg-secondary text-white py-1'
                onClick={() => {
                  setInsertBookmarkPrescriptionModal(true)
                }}
                disabled={isPreview}
              >
                ثبت نسخه به برگزیده
              </Button>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
      <RaytebModal
        isOpen={showBookmark}
        hideModal={() => {
          setShowBookmark(false)
        }}
        onAfterOpen={() => {
          listBookmark.reFetch()
        }}
        title='لیست نسخه های پرگزیده'
        className={'p-2 relative w-96'}
        onAfterClose={() => setShowListBookmark(true)}
      >
        <LoadingFit isLoading={listBookmark.isLoading || addChosen.isLoading} />
        <div className='py-3 h-80 overflow-y-auto'>
          {showListBookmark ? (
            <>
              <TextBox
                innerText='جستجو'
                Type={TextBoxTypeEnum.Text}
                debounceTime={0}
                onChange={(e) => {
                  const bookmarks = listBookmark.result?.filter((x) =>
                    x.title.includes(e.target.value)
                  )
                  setListBookmarkSearch(bookmarks)
                }}
              />
              <Table>
                <thead className='text-xs text-primary h-8 border-b border-disable'>
                  <tr>
                    <th
                      scope='col'
                      className='pt-1 p-0 text-center font-normal w-10'
                    >
                      #
                    </th>
                    <th
                      scope='col'
                      className='pt-1 p-0 text-center font-normal'
                    >
                      نام
                    </th>
                    <th
                      scope='col'
                      className='pt-1 pl-2 text-center font-normal w-10'
                    >
                      عملیات
                    </th>
                  </tr>
                </thead>
                <tbody className='text-xs'>
                  {listBookmarkSearch?.map((item, i) => (
                    <tr className={`[&>*]:h-14`} key={i}>
                      <td className='text-center'>{i + 1}</td>
                      <td className='text-center'>
                        {item.title?.shortText(20)}
                      </td>

                      <td className='grid grid-cols-2 justify-items-center p-1 gap-3'>
                        <Icon
                          icon='rayteb-delete'
                          className='text-[17px] text-danger'
                          onClick={() => {
                            bookmarkDelete.reFetch(null, {
                              bookmarkId: item.id,
                            })
                          }}
                        />
                        <Icon
                          icon='rayteb-add-circular'
                          className='text-[17px] text-secondary'
                          onClick={() => {
                            addChosen.reFetch(null, {
                              prescriptionId: prescriptionId!,
                              laboratoryId: item.prescriptionId,
                            })
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <div className='w-full px-2'>
              <div className='text-xs grid grid-cols-8 justify-items-start items-center gap-3'>
                <span className='col-span-3'>نام</span>
                <span className='col-span-1'>مقدار</span>
                <span className='col-span-2'>تاریخ تکرار</span>
                {listAddedChosen.rows?.map((row, i) => (
                  <>
                    <span className='text-center flex justify-center items-center col-span-3'>
                      {row.title?.shortText(13)}
                    </span>
                    <span className='text-center flex justify-center items-center col-span-1'>
                      {row.amount}
                    </span>
                    <span className='text-center flex justify-center items-center col-span-2'>
                      {row.effectiveDate
                        ? new Date(row.effectiveDate).toShamsi()
                        : ''}
                    </span>
                    {row.messages?.map((n) => (
                      <>
                        <span
                          className={`col-span-8 w-full py-1 border-b ${n.flag === ErrorTypeEnum.Error
                            ? 'text-danger'
                            : n.flag === ErrorTypeEnum.Info
                              ? 'text-primaryLight'
                              : n.flag === ErrorTypeEnum.Warning
                                ? 'text-warn'
                                : ''
                            }`}
                        >
                          {n.message}
                        </span>
                      </>
                    ))}
                  </>
                ))}
              </div>
            </div>
          )}
        </div>
      </RaytebModal>
      <RaytebModal
        isOpen={insertBookmarkPrescriptionModal}
        hideModal={() => setInsertBookmarkPrescriptionModal(false)}
        title='ثبت نسخه برگزیده'
      >
        <LoadingFit isLoading={bookmark.isLoading} />
        <RaytebForm
          className='flex justify-center items-center flex-col gap-5 py-6'
          checkIsRequired={true}
          onSubmit={(e) => {
            bookmark.reFetch(null, {
              laboratoryId: laboratory.id!,
              title: e.currentTarget['bookmark'].value,
            })
          }}
        >
          <div className='w-[80%]'>
            <TextBox
              Type={TextBoxTypeEnum.Text}
              isRequired={true}
              innerText='عنوان نسخه برگزیده'
              name='bookmark'
            />
          </div>
          <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
            <Button
              type='button'
              onClick={() => {
                setInsertBookmarkPrescriptionModal(false)
              }}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      </RaytebModal>
      <RaytebModal
        isOpen={price.show ?? false}
        hideModal={() => setPrice({ show: false })}
        title='قیمت خدمت'
      >
        <div className='p-2'>
          <Table>
            <thead className='text-xs text-primary h-8 border-b border-disable'>
              <tr>
                <th
                  scope='col'
                  className='pt-1 p-0 text-center font-normal w-10'
                >
                  سهم سازمان
                </th>
                <th scope='col' className='pt-1 p-0 text-center font-normal'>
                  سهم بیمار
                </th>
                <th
                  scope='col'
                  className='pt-1 pl-2 text-center font-normal w-10'
                >
                  کل
                </th>
              </tr>
            </thead>
            <tbody className='text-xs'>
              <tr className={`[&>*]:h-14`}>
                <td className='text-center'>{price.insureShare}</td>
                <td className='text-center'>{price.patientShare}</td>

                <td className='text-center'>{price.total}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-xs w-full flex flex-col gap-3'>
            {price.messages?.map((n) => (
              <span
                className={`${n.flag === ErrorTypeEnum.Error
                  ? 'text-danger'
                  : n.flag === ErrorTypeEnum.Info
                    ? 'text-primaryLight'
                    : n.flag === ErrorTypeEnum.Warning
                      ? 'text-warn'
                      : ''
                  }`}
              >
                {n.message}
              </span>
            ))}
          </div>
        </div>
      </RaytebModal>
    </div>
  )
}

type ListChildrenType = {
  listData?: Array<LaboratoryServeViewModel>
  className?: string | undefined
  isLoading: boolean
  onHide?: () => void
  onClick?: (param: LaboratoryServeViewModel) => void
}
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          <p className='text-xs mr-2 font-bold text-warn  '>
            برای تجویز بر روی یکی از موارد کلیک کنید
          </p>
        </div>

        <div className='h-64 overflow-y-auto'>
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm  ${className ?? ''}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className='flex justify-start items-center py-1  w-full hover:bg-primaryDefault hover:cursor-pointer'
                onClick={() => onClick?.(n)}
              >
                <p className='text-xs font-bold text-end text-primaryLight'>
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
export default React.memo(Laboratory)
